import React from 'react';
import { ScheduleListItem } from '../../../api/model';
import SlideToggle from '../../modules/SlideToggle';
import { periodStr } from './ScheduleListIndexArea';
import { getFormattedYYMMDDFromStr } from './SchedulelistCommon';

interface childrenIndexRowProp {
  /** 親日程 */
  chart: ScheduleListItem;
  /** 子日程表示非表示判定関数 */
  isShowChild: (targetProductionId: string) => boolean;
}

/**
 * 子日程要素描画用
 * @param param0
 * @returns
 */
function ScheduleListIndexChildRow({ chart, isShowChild }: childrenIndexRowProp): JSX.Element {
  const { children } = chart;

  /** 子日程が存在しない場合:親コンポーネントで処理しているため、以下のif文には入らない想定 */
  if (children === undefined) {
    return <tr />;
  }

  return (
    <>
      {children.map((child) => (
        <React.Fragment key={chart.production_id + child.production_id}>
          <ChildIndexRow
            key={chart.production_id + child.production_id}
            chart={chart}
            isShowChild={isShowChild}
            child={child}
          />
        </React.Fragment>
      ))}
    </>
  );
}

interface childIndexRowProp {
  /** 親日程 */
  chart: ScheduleListItem;
  /** 子日程 */
  child: ScheduleListItem;
  /** 子日程表示非表示判定関数 */
  isShowChild: (targetProductionId: string) => boolean;
}

/**
 * 子日程行
 * @param param0
 * @returns
 */
function ChildIndexRow({ chart, isShowChild, child }: childIndexRowProp) {
  const isShowChildFlg = isShowChild(chart.production_no);
  return (
    <tr
      className="childtr"
      key={`${chart.production_id}-${child.production_id}`}
      data-key-str={`${chart.production_id}-${child.production_id}`}
    >
      {/* isShowChild()で表示非表示をチェックする。非表示の場合、行の高さを0にしたいので、none-paddingクラスを付与する */}
      {/* 資料管理No. */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>└{child.production_no}</SlideToggle>
      </td>
      {/* 資料区分名 */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{child.production_division_name}</SlideToggle>
      </td>
      {/* 言語名 */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{child.language_name}</SlideToggle>
      </td>
      {/* 原作メーカー名 */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{child.maker_company_name}</SlideToggle>
      </td>
      {/* 制作前（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.preproduction.plan_from_on, child.preproduction.plan_end_on)}
        </SlideToggle>
      </td>
      {/* 制作前（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.preproduction.actual_from_on, child.preproduction.actual_end_on)}
        </SlideToggle>
      </td>
      {/* G1（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g1.plan_from_on, child.g1.plan_end_on)}</SlideToggle>
      </td>
      {/* G1（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g1.actual_from_on, child.g1.actual_end_on)}</SlideToggle>
      </td>
      {/* G2（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g2.plan_from_on, child.g2.plan_end_on)}</SlideToggle>
      </td>
      {/* G2（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g2.actual_from_on, child.g2.actual_end_on)}</SlideToggle>
      </td>
      {/* G3（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g3.plan_from_on, child.g3.plan_end_on)}</SlideToggle>
      </td>
      {/* G3（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g3.actual_from_on, child.g3.actual_end_on)}</SlideToggle>
      </td>
      {/* G4（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g4.plan_from_on, child.g4.plan_end_on)}</SlideToggle>
      </td>
      {/* G4（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{periodStr(child.g4.actual_from_on, child.g4.actual_end_on)}</SlideToggle>
      </td>
      {/* 完成日（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.completion.plan_from_on, child.completion.plan_end_on)}
        </SlideToggle>
      </td>
      {/* 完成日（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.completion.actual_from_on, child.completion.actual_end_on)}
        </SlideToggle>
      </td>
      {/* 量産日 */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>{getFormattedYYMMDDFromStr(child.mass_production)}</SlideToggle>
      </td>
      {/* ドラフト翻訳日（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.draft_translation.plan_from_on, child.draft_translation.plan_end_on)}
        </SlideToggle>
      </td>
      {/* ドラフト翻訳日（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.draft_translation.actual_from_on, child.draft_translation.actual_end_on)}
        </SlideToggle>
      </td>
      {/* 最終翻訳日（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.final_translation?.plan_from_on, child.final_translation?.plan_end_on)}
        </SlideToggle>
      </td>
      {/* 最終翻訳日（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.final_translation?.actual_from_on, child.final_translation?.actual_end_on)}
        </SlideToggle>
      </td>
      {/* 他言語編集依頼日（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.other_language_edit_request?.plan_from_on, child.other_language_edit_request?.plan_end_on)}
        </SlideToggle>
      </td>
      {/* 他言語編集依頼日（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(
            child.other_language_edit_request?.actual_from_on,
            child.other_language_edit_request?.actual_end_on
          )}
        </SlideToggle>
      </td>
      {/* データトス日（予定） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.data_toss.plan_from_on, child.data_toss.plan_end_on)}
        </SlideToggle>
      </td>
      {/* データトス日（実績） */}
      <td className={`${!isShowChildFlg ? 'none-padding' : ''}`}>
        <SlideToggle open={isShowChildFlg}>
          {periodStr(child.data_toss.actual_from_on, child.data_toss.actual_end_on)}
        </SlideToggle>
      </td>
    </tr>
  );
}

export default ScheduleListIndexChildRow;
